function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 70,
  r: 70,
  fill: "#0085FF",
  fillOpacity: 0.08
});
var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#user-empty-state_svg__filter0_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 41,
  width: 149,
  height: 24,
  rx: 1.532,
  fill: "#fff"
}));
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 66,
  y: 46,
  width: 57,
  height: 14,
  rx: 2,
  fill: "#DBDFE5"
});
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 68,
  y: 49,
  width: 52,
  height: 8,
  rx: 2,
  fill: "#fff"
});
var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 128,
  y: 46,
  width: 40,
  height: 14,
  rx: 2,
  fill: "#0085FF"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M148.471 55.994a.53.53 0 101.059 0h-1.059zm1.059-5.99a.53.53 0 00-1.059 0h1.059zm2.465 3.525a.53.53 0 000-1.059v1.059zm-5.99-1.059a.53.53 0 000 1.059V52.47zm3.525 3.524v-5.99h-1.059v5.99h1.059zm2.465-3.524h-5.99v1.059h5.99V52.47z",
  fill: "#fff"
});
var _ref7 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#user-empty-state_svg__filter1_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 35,
  y: 78,
  width: 138,
  height: 18,
  rx: 1.532,
  fill: "#fff"
}));
var _ref8 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fill: "#A0AFBE",
  d: "M52 83h116v8H52z"
});
var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 86.5,
  r: 12.5,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 2
});
var _ref0 = /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 86.5,
  r: 11.5,
  fill: "#DBDFE5"
});
var _ref1 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#user-empty-state_svg__a)",
  fill: "#A0AFBE"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 98,
  r: 11.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 82.841,
  r: 5.662,
  stroke: "#DBDFE5",
  strokeWidth: 1.914
}));
var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "user-empty-state_svg__filter0_d",
  x: 16,
  y: 35,
  width: 165,
  height: 40,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "user-empty-state_svg__filter1_d",
  x: 27,
  y: 72,
  width: 154,
  height: 34,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));
function SvgUserEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 140,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, /*#__PURE__*/React.createElement("mask", {
    id: "user-empty-state_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 75,
    width: 23,
    height: 23
  }, _ref0), _ref1, _ref10);
}
export default SvgUserEmptyState;